export default __webpack_public_path__ + "static/media/Pistol_5.bb612a6c.png";